import useLiveChatActions from './useLiveChatActions';

export default function useLiveChatToggle(): () => void {
  const { toggle } = useLiveChatActions();
  return toggle;
}
